<template>

  <v-expansion-panels>

    <v-expansion-panel>

      <v-expansion-panel-header class="grey lighten-2">
        How We Calculate Recommended Speed
      </v-expansion-panel-header>

      <v-expansion-panel-content class="white">

        <v-layout align-center>

          <v-flex xs12 sm6 class="text-justify">
            <!-- Residential -->
            <div
              v-if="$store.state.wizard.preferences.useCategory && $store.state.wizard.preferences.useCategory.text === 'Residential'">

              <div class="my-2">
                You selected a Use Pattern of <code>{{usePattern}}.</code>
              </div>

              <div class="my-4">
                We equate your scale selection of <code>{{preferences.scale.text}}</code>
                to a household size of <code>{{scale}}</code>, and we recommend
                <code>{{recommendedPerUser}} Mbps</code> per person for a total of
                <code>{{$helpers.formatSpeed(speedPreference)}}.</code>
              </div>

            </div>

            <!-- Business-->
            <div v-else>

              <div class="my-2">
                You selected a Use Pattern of <code>{{businessSpeed}}.</code>
              </div>

              <div class="my-4">
                Based on your expected capacity of <code>{{capacity}}</code> {{usersLabel}} in
                the
                <code>{{preferences.businessType.text}}</code> category, we recommend
                <code>{{recommendedPerUser}} Mbps</code> per {{usersLabel}} for a total of
                <code>{{$helpers.formatSpeed(speedPreference)}}.</code>
              </div>

            </div>
          </v-flex>

          <v-flex xs12 sm6 class="text-center">

            Formula:

            <v-chip large label color="primary">
              {{recommendedPerUser}} Mbps
            </v-chip>

            <v-icon large class="mx-1">mdi-close</v-icon>

            <v-chip large label color="primary">
              {{capacity}} users
            </v-chip>

            <v-icon large class="mx-1">mdi-equal</v-icon>

            <v-chip large label color="primary">
              {{$helpers.formatSpeed(speedPreference)}}
              <div class="position-absolute font-xs-small" style="bottom: 0;"
                   v-if="$helpers.formatSpeed(speedPreference) !== `${speedPreference} Mbps`">
                ({{speedPreference}} Mbps)
              </div>
            </v-chip>

          </v-flex>

        </v-layout>

        You can adjust the preferences in the Wizard Preferences section to observe changes in
        realtime.

      </v-expansion-panel-content>

    </v-expansion-panel>

  </v-expansion-panels>

</template>

<script>
import { mapGetters } from 'vuex';

const name = 'SpeedCalcDescription';

export default {

  name,

  props: {

    preferences: {
      type: Object,
      required: true,
    },

    speedPreference: {
      type: [String, Number],
      required: true,
    },

  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters([
      'businessSpeed',
      'recommendedPerUser',
      'capacity',
      'usersLabel',
      'usePattern',
      'scale',
    ]),
  },

};
</script>
